import _ from "lodash";
import React from "react";
import { connect } from "react-redux";
import { graphql, compose } from "lib/apolloClient";
import classes from "./OrganizationV2.scss";
import moment from "moment";
import I18nHOC from "UIComponents/I18nHOC";
import DialogueBox from "UIComponents/DialogueBox";
import withLoader from "UIComponents/GqlWithLoader";
import Loading from "UIComponents/Loading";
import FilterCountBlock from "UIComponents/FilterCountBlock";
import BulkUploadErrorModal from "UIComponents/BulkUploadErrorModal";
import FullScreenLoader from "UIComponents/FullScreenLoader";
import UIModal from "UIComponents/UIModal";
import { getOrganizationFeedQuery } from "Tooling/modules/ToolingQueries";
import { getOrganizationFeedFromCache } from "Tooling/modules/ToolingGraphqlHelpers";
import EditOrgInfo from "./components/EditOrgInfo";
import TopHeader from "./components/TopHeader";
import FilterContainer from "./components/FilterContainer";
import FeedList from "AppComponents/FeedList";
import { goToBack } from "modules/NavigationModule";
import {
  createOrganization,
  bulkUpload,
  changeOrganizationSearchString,
  deleteOrganization,
  updateConfigurablePermissions,
  updateOrganizationFilters,
  updateOrganizationPaidStatus,
  updateCurriculumPrograms,
  updateOrganizationBasicDetails,
  getValidAdminsPayload,
  bulkDownloadOrganizationData,
  applyCustomColumnStyles,
  editSchoolCloudStorageAccount,
} from "Tooling/modules/ToolingModule";
import { styles } from "./OrganizationV2Styles";
import {
  ALLSCHOOLS_SCHOOL_PAGE_COLUMNS,
  TRANSITION_SCHOOL_PAGE_COLUMNS,
} from "Tooling/modules/ToolingUtils";
import { onSwitchToOrganization, setToastMsg } from "Login/modules/LoginModule";
import { checkScrollAtBottom } from "Utils";
import {
  OrganizationBasicDetails,
  ToddleBuddiesBasicDetails,
  CurriculumPlanDetails,
  OrganizationStatus,
  SchoolInfo,
  ManageTagsModal,
} from "./components";
import { withCombinedAccessBlocker } from "lib/PermissionAware";
import {
  CURRICULUM_TYPE_DP,
  ORGANIZATIONS,
  CREATE_ORGANIZATION,
  DELETE_ORGANIZATION,
  MICROSOFT_SERVICE_TYPE,
} from "Constants/stringConstants";
import ACLStore from "lib/aclStore";
import { ORGANIZATION_LOGO_PLACEHOLDER_URL } from "Constants";
import { getOrganizationFreeStatus } from "Platform/modules/PlatformUtils";
import {
  REGION_NAME_BY_PORTAL_TYPE,
  REGION_NAME_BY_REGION,
  PORTAL_TYPE_BY_REGION,
} from "Platform/routes/Regions/modules/Module";
import {
  getTransitionFilters,
  getCurriculumPlanFilters,
  getFiltersMemoized,
  getIsPaidOrganizationValue,
  addDisplayOrderIndex,
} from "./OrganizationV2Utils";
import UpdateOrgAcademicYears from "./components/UpdateOrgAcademicYears";
import EditStorageAcountModal from "./components/EditStorageAcountModal";
import { convertDataJSONToXLSX, goToRelativeRoute } from "modules/Services";
import { saveAs } from "file-saver";
import { setPortalType } from "Login/modules/LoginModule";
import {
  ChevronRightOutlined,
  DotsHorizontalOutlined,
  InformationFilled,
} from "@toddle-edu/ds-icons";
import {
  Tooltip,
  IconButton,
  Dropdown,
  DropdownMenu,
} from "@toddle-edu/ds-web";
import { Tooltip as TooltipAppComp } from "AppComponents/ArchivedComponents";
import { IDENTITY_CONFIGURATION_TYPE_TO_PERM_MAP } from "Constants/permissionConstants";

const OrganizationList = compose(withLoader)(FeedList);

const DeleteSchoolDialogueMessage = props => {
  const { orgDetail } = props;

  return (
    <div>
      <div style={{ marginBottom: "16px", color: "red" }}>
        {`Are you sure you want to delete the School? This action can't be undone.`}
      </div>
      <div>
        <b>School name: </b>
        {orgDetail.name}
      </div>
      <div>
        <b>School id: </b>
        {orgDetail.id}
      </div>
    </div>
  );
};

const DIALOGS_INFO = {
  DELETE_ORGANIZATION: {
    title: "Delete School",
    message: DeleteSchoolDialogueMessage,
    confirmButtonText: "Delete",
    cancelButtonText: "Cancel",
  },
};

const customModalStyle = {
  overlay: { overflow: "unset" },
  content: { overflow: "unset" },
};

class OrganizationV2 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mode: "create",
      isCreate: true,
      modalOpen: false,
      academicYearModalOpen: false,
      bulkUploadErrorModal: false,
      selectedOrgId: null,
      errors: [],
      isLoading: false,
      currentDialogAction: false,
      schoolInfoModalOpen: false,
      manageTagsModalOpen: false,
      editStorageAccountModalOpen: false,
      selectedOrganization: null,
    };
  }

  componentWillUnmount = () => {
    this.setState({ isLoading: false });
  };

  setIsLoading = isLoading => {
    this.setState({ isLoading });
  };

  openModalCreateModeal = () => {
    this.setState({ modalOpen: true, mode: "create" });
  };

  closeModal = () => {
    const { setPortalType } = this.props;

    setPortalType(null);

    this.setState({
      modalOpen: false,
      academicYearModalOpen: false,
      dpCurriculumProgramId: null,
    });
  };

  onClickEditOrgAcademicYear = id => {
    this.setState({
      academicYearModalOpen: true,
      mode: "editAcademicYear",
      selectedOrgId: id,
    });
  };

  toggleDialogueBoxDisplay = () => {
    this.setState({
      currentDialogAction: false,
    });
  };

  onManageCurriculumPrograms = id => {
    this.setState({
      modalOpen: true,
      mode: "editCurriculumPrograms",
      selectedOrgId: id,
    });
  };

  onClickEditSchoolInformation = id => {
    this.setState({
      modalOpen: true,
      mode: "editBasicDetails",
      selectedOrgId: id,
    });
  };

  onClickEditOrgSetting = id => {
    this.setState({
      settingModalOpen: true,
      mode: "editSetting",
      selectedOrgId: id,
    });
  };

  changeSearchTerm = value => {
    this.props.changeOrganizationSearchString({ organizations: value });
  };

  toggleBulkUploadErrorModal = () => {
    this.setState({
      bulkUploadErrorModal: !this.state.bulkUploadErrorModal,
    });
  };

  onClickDeleteOrg = id => {
    this.setState({
      currentDialogAction: "DELETE_ORGANIZATION",
      selectedOrgId: id,
    });
  };

  setPortalTypeByRegion = region => {
    const { setPortalType } = this.props;
    setPortalType(PORTAL_TYPE_BY_REGION[region]);
  };

  resetPortalType = () => {
    this.props.setPortalType(null);
  };

  onClickCurriculumDataDownload = async ({
    organizationId,
    curriculumProgramId,
    region,
  }) => {
    const { bulkDownloadOrganizationData, setToastMsg } = this.props;

    this.setPortalTypeByRegion(region);

    try {
      const data = await bulkDownloadOrganizationData({
        filters: {
          organizationId,
          curriculumProgramId,
        },
      });

      const xlsxDataBlob = await convertDataJSONToXLSX({
        jsonSheetData: data,
        applyCustomStyles: applyCustomColumnStyles,
      });
      saveAs(xlsxDataBlob, `${data.filename}.xlsx`);

      this.resetPortalType();
    } catch (error) {
      setToastMsg("toastMsgs:something_went_wrong");
    }
  };

  onClickManageTags = params => {
    const { organization } = params;
    this.setState({
      selectedOrganization: organization,
      manageTagsModalOpen: true,
    });
  };

  onClickEditStorageAccount = id => {
    this.setState({
      selectedOrgId: id,
      editStorageAccountModalOpen: true,
    });
  };

  getCurriculumOptions = item => {
    const curriculumPrograms = _.get(item, "curriculumPrograms", []);
    return _.map(curriculumPrograms, curriculumProgram => {
      return {
        label: curriculumProgram.acronym,
        key: `DOWNLOAD_CURRICULUM_DATA-${curriculumProgram.id}`,
      };
    });
  };

  getSelectedCloudStorageLabel = ({
    isCloudStorageSelected,
    cloudStorageType,
  }) => {
    if (isCloudStorageSelected) {
      // Check if the selected cloud storage type includes 'MICROSOFT_SERVICE_TYPE'
      if (_.includes(cloudStorageType, MICROSOFT_SERVICE_TYPE)) {
        // If it includes, return 'Microsoft' as the label
        return "Microsoft";
      }
      // Return 'Google' as the default label if the selected cloud storage type is not 'MICROSOFT_SERVICE_TYPE'
      return "Google";
    }
  };

  getActionMenu = item => {
    const {
      t,
      isDeleteOrganizationEnabled,
      enableEditCloudStorageAccount,
    } = this.props;

    const isPaid = _.get(item, "isPaid", false);

    const curriculumPrograms = _.get(item, "curriculumPrograms", []);
    const isOrganizationFree = getOrganizationFreeStatus({
      curriculumPrograms,
    });

    const commonOptions = [
      isOrganizationFree
        ? {
            key: "EDIT_SCHOOL_INFORMATION",
            label: t("common:edit_with_label", {
              label: t("common:school_information"),
            }),
          }
        : {
            key: "MANAGE_CURRICULUM_PROGRAMS",
            label: t("onBoarding:manage_curriculum_programs"),
          },
      // We can manage academic years from school setup too so commenting this out
      // {
      //   key: "MANAGE_ACADEMIC_YEARS",
      //   label: "Manage academic years",
      // },
      {
        options: this.getCurriculumOptions(item),
        key: "DOWNLOAD_CURRICULUM_DATA",
        label: t("common:download_with_lowercase_label", {
          label: t("onBoarding:curriculum_data"),
        }),
        isSubMenu: true,
      },
      {
        key: "UPDATE_PAID_STATUS",
        label: t("common:mark_as_label", {
          label: isPaid ? t("onBoarding:unpaid") : t("onBoarding:paid"),
        }),
      },
      {
        key: "MANAGE_TAGS",
        label: t("common:manage_with_label", {
          label: t("common:tags"),
        }),
      },
    ];

    //  Add-on Manager
    const enableAddOnsManager = ACLStore.can("FeatureFlag:AddOnManager");
    if (enableAddOnsManager) {
      const addOnManagerOption = {
        key: "ADD_ON_MANAGER",
        label: "Add-on manager",
      };
      commonOptions.push(addOnManagerOption);
    }

    // add option to edit storage acount here based on identity check and based on THIRD_PARTY_STORAGE_PREFERNCE
    const cloudStorageType = _.toUpper(
      _.get(item, "globalConstants[0].value", "")
    );
    const isCloudStorageSelected = !_.includes(cloudStorageType, "NONE");

    if (enableEditCloudStorageAccount) {
      const editCloudStoraceAccount = {
        key: "EDIT_STORAGE_ACCOUNT",
        label: t("onBoarding:edit_cloud_storge_account"),
        disabled: isCloudStorageSelected,
        disabledTooltip: t(
          "onBoarding:selected_cloud_storage_account_with_label",
          {
            label: this.getSelectedCloudStorageLabel({
              isCloudStorageSelected,
              cloudStorageType,
            }),
          }
        ),
      };
      commonOptions.push(editCloudStoraceAccount);
    }

    const deleteOrganizationOption = {
      key: "DELETE_ORGANIZATION",
      label: t("common:delete_with_label", { label: t("common:school") }),
    };
    if (isPaid && isDeleteOrganizationEnabled) {
      commonOptions.push(deleteOrganizationOption);
    } else if (!isPaid) {
      // If a school is on free plan anyone can delete it
      commonOptions.push(deleteOrganizationOption);
    }

    return commonOptions;
  };

  redirectToAddOnManager = ({ orgId }) => {
    const { goToRelativeRoute } = this.props;
    goToRelativeRoute({ route: `addOnManager/${orgId}` });
  };

  onActionMenuItemClick = async ({ key, organization }) => {
    const { updateOrganizationPaidStatus, getOrganizationFeed } = this.props;

    this.setPortalTypeByRegion(organization.region);

    switch (key) {
      case "MANAGE_CURRICULUM_PROGRAMS": {
        this.onManageCurriculumPrograms(organization.id);
        break;
      }
      case "EDIT_SCHOOL_INFORMATION": {
        this.onClickEditSchoolInformation(organization.id);
        break;
      }
      case "MANAGE_ACADEMIC_YEARS": {
        this.onClickEditOrgAcademicYear(organization.id);
        break;
      }
      case "DELETE_ORGANIZATION": {
        this.onClickDeleteOrg(organization.id);
        break;
      }
      case "EDIT_STORAGE_ACCOUNT": {
        this.onClickEditStorageAccount(organization.id);
        break;
      }

      case "UPDATE_PAID_STATUS": {
        try {
          await updateOrganizationPaidStatus({
            input: {
              organizationId: organization.id,
              isPaid: !organization.isPaid,
            },
            queryVariables: getOrganizationFeed.variables,
          });

          this.resetPortalType();
        } catch {}
        break;
      }

      case "MANAGE_TAGS": {
        this.onClickManageTags({ organization });
        break;
      }

      case "ADD_ON_MANAGER": {
        this.redirectToAddOnManager({ orgId: organization.id });
        break;
      }

      default: {
        if (_.startsWith(key, "DOWNLOAD_CURRICULUM_DATA")) {
          const curriculumProgramId = key.split("-")[1];
          this.onClickCurriculumDataDownload({
            organizationId: organization.id,
            region: organization.region,
            curriculumProgramId,
          });
        }
      }
    }
  };

  getFeedDataV2 = () => {
    const { organizations, activeTab, portalType } = this.props;

    return _.map(organizations, ({ node: organization }) => {
      const { id, name, logo, curriculumPrograms, region, tags } = organization;
      const regionName = region
        ? REGION_NAME_BY_REGION[region]
        : REGION_NAME_BY_PORTAL_TYPE[portalType];
      const orgIdWithRegionName = `${id} (${regionName})`;
      const commonFeedData = {
        id: `${id} ${region}`,
        SCHOOL_DETAILS: {
          id: orgIdWithRegionName,
          name,
          profileImage: _.isEmpty(logo)
            ? ORGANIZATION_LOGO_PLACEHOLDER_URL
            : logo,
        },
        TODDLE_BUDDIES: { curriculumPrograms },
        ACTIONS: {
          tabs: this.getActionMenu(organization),
          onActionMenuItemClick: ({ key, domEvent }) => {
            domEvent?.preventDefault();
            this.onActionMenuItemClick({ key, organization });
          },
        },
        SWITCH_ORGANIZATION: {
          onViewClick: e => {
            e?.preventDefault();
            this.onSwitchToOrganization({ id: organization.id, region });
          },
          onClickInfoIcon: e => {
            e?.preventDefault();
            this.setState({
              schoolInfoModalOpen: true,
              selectedOrganization: organization,
            });
          },
        },
        TAGS: {
          tags,
        },
      };

      switch (activeTab) {
        case "ALL_SCHOOLS": {
          return {
            ...commonFeedData,
            PLAN: curriculumPrograms,
            TOTAL_CLASSES: _.get(
              organization,
              "organizationAnalytics.courseCount",
              "-"
            ),
            TOTAL_STAFFS: _.get(
              organization,
              "organizationAnalytics.staffCount",
              "-"
            ),
            TOTAL_STUDENTS: _.get(
              organization,
              "organizationAnalytics.studentCount",
              "-"
            ),
          };
        }
        case "TRANSITION": {
          return {
            ...commonFeedData,
            PROGRAMS: curriculumPrograms,
            STATUS: _.get(organization, "currentAcademicYear", []),
          };
        }
      }
    });
  };

  getCustomColumnElement = ({ column, columnData }) => {
    switch (column.id) {
      case "SCHOOL_DETAILS": {
        return <OrganizationBasicDetails {...columnData} />;
      }
      case "TAGS": {
        const { tags } = columnData;
        return (
          <TooltipAppComp
            data={tags}
            label={"Tags assigned"}
            keyToMap="value"
            emptyTextStyle={{}}
            length={1}
          />
        );
      }
      case "TODDLE_BUDDIES": {
        return (
          <ToddleBuddiesBasicDetails
            curriculumPrograms={columnData.curriculumPrograms}
          />
        );
      }
      case "PROGRAMS": {
        return <CurriculumPlanDetails curriculumPrograms={columnData} />;
      }
      case "ACTIONS": {
        const { onActionMenuItemClick, tabs } = columnData;

        return (
          <Dropdown
            overlay={
              <DropdownMenu onClick={onActionMenuItemClick} options={tabs} />
            }
          >
            <IconButton
              icon={<DotsHorizontalOutlined />}
              variant="plain"
              size="small"
            />
          </Dropdown>
        );
      }
      case "PLAN":
      case "SETUP_COMPLETE":
      case "NOT_STARTED":
      case "IN_PROGRESS":
      case "QC_INITIATED":
      case "IN_30_7":
      case "IN_7_0":
      case "OVERDUE": {
        return (
          <CurriculumPlanDetails
            curriculumPrograms={columnData}
            showPlanNameInTooltip
          />
        );
      }
      case "STATUS": {
        return <OrganizationStatus currentAcademicYear={columnData} />;
      }

      case "SWITCH_ORGANIZATION": {
        return (
          <div className={classes.buttonContainer}>
            <IconButton
              icon={<InformationFilled />}
              variant="outlined"
              size="small"
              onClick={columnData.onClickInfoIcon}
            />
            <Tooltip tooltip={"Switch to this school"} placement="top">
              <IconButton
                icon={<ChevronRightOutlined />}
                variant="outlined"
                size="small"
                onClick={columnData.onViewClick}
              />
            </Tooltip>
          </div>
        );
      }

      default: {
        return <div>{column.id}</div>;
      }
    }
  };

  getFeedListParentStyle = () => {
    const { activeTab } = this.props;
    switch (activeTab) {
      case "ALL_SCHOOLS": {
        return styles.allSchoolsFeedListStyles.parentStyle;
      }
      case "TRANSITION": {
        return styles.transitionFeedListStyles.parentStyle;
      }
    }
  };

  getDPCurriculumProgram = ({ curriculumPrograms }) => {
    const dpCurriculumProgram = _.find(
      curriculumPrograms,
      ({ type }) => type === CURRICULUM_TYPE_DP
    );

    return dpCurriculumProgram || {};
  };

  getAcademicYearsPayload = ({ academicYears }) => {
    return _.map(academicYears, academicYear => {
      return {
        startDate: moment(academicYear?.dateDurationValue?.startDate).format(
          "YYYY-MM-DD"
        ),
        endDate: moment(academicYear?.dateDurationValue?.endDate).format(
          "YYYY-MM-DD"
        ),
      };
    });
  };

  getCurriculumOptionsPayload = ({
    curriculumPrograms,
    shouldIncludeId = false,
  }) => {
    return _.map(curriculumPrograms, curriculumProgram => {
      const {
        type,
        acronym,
        rosteringMethod,
        toddleBuddy,
        plan,
        grades,
        name,
        id,
        programDataLanguages,
        variant,
        dealId,
        platformId,
        curriculumProgramData,
        displayOrder,
        examSessionMonth,
      } = curriculumProgram;

      return {
        ...(shouldIncludeId ? { id } : {}),
        curriculumType: type,
        rosteringMethod,
        toddleBuddyId: toddleBuddy,
        planId: plan,
        gradesToBeIncluded: grades,
        label: name,
        acronym,
        ...(programDataLanguages && { programDataLanguages }),
        ...(variant && { variant }),
        dealId,
        ...(!_.isEmpty(platformId) && { platformId }),
        curriculumProgramData: _.omit(curriculumProgramData, "__typename"),
        displayOrder,
        examSessionMonth,
      };
    });
  };

  getSchedularPayload = ({
    schedulerStartTime,
    schedulerEndTime,
    schedulerWeekLength,
  }) => {
    return {
      schedulerStartTime: moment(schedulerStartTime).format("HH:mm"),
      schedulerEndTime: moment(schedulerEndTime).format("HH:mm"),
      schedulerWeekLength: parseInt(schedulerWeekLength),
    };
  };

  createOrganization = async orgDetails => {
    const { getOrganizationFeed, createOrganization } = this.props;

    const {
      schedulerStartTime,
      schedulerEndTime,
      schedulerWeekLength,
      curriculumPrograms,
      admins,
      schedulerStartDay,
      storageType,
      timezone,
    } = orgDetails;

    const dpCurriculumProgram = this.getDPCurriculumProgram({
      curriculumPrograms,
    });

    const {
      examSessionMonth = null,
      examSessionTimezone = null,
    } = dpCurriculumProgram;

    const validAdmins = getValidAdminsPayload({ admins });

    const academicYears = this.getAcademicYearsPayload({
      academicYears: orgDetails["academicYears"],
    });

    const timezoneWrapper = timezone
      ? [
          {
            name: "TIMEZONE",
            value: timezone,
          },
        ]
      : [];

    const {
      schedulerStartTime: startTime,
      schedulerEndTime: endTime,
      schedulerWeekLength: weekLength,
    } = this.getSchedularPayload({
      schedulerStartTime,
      schedulerEndTime,
      schedulerWeekLength,
    });

    let updatedOrgDetails = {
      ...orgDetails,
      academicYears,
      admins: validAdmins,
      examSessionMonth,
      timezone: examSessionTimezone,
      curriculumOptions: this.getCurriculumOptionsPayload({
        curriculumPrograms,
      }),
      scheduler: {
        startDay: schedulerStartDay,
        startTime,
        endTime,
        weekLength,
      },

      organizationConstants: [
        {
          name: "OPERATIONAL_DAYS",
          value: JSON.stringify(orgDetails["operationalDays"]),
        },
        ...timezoneWrapper,
      ],
    };
    if (!_.isEmpty(storageType)) {
      updatedOrgDetails.organizationConstants.push({
        name: "THIRD_PARTY_SERVICE_TYPE_PREFERENCE",
        value: JSON.stringify([storageType]),
      });
    }

    updatedOrgDetails = _.omit(updatedOrgDetails, [
      "operationalDays",
      "curriculumPrograms",
      "toddleBuddy",
      "schedulerStartTime",
      "schedulerEndTime",
      "schedulerWeekLength",
      "schedulerStartDay",
      "storageType",
    ]);

    try {
      this.setState({ isLoading: true });
      await createOrganization(updatedOrgDetails);

      this.resetPortalType();

      await getOrganizationFeed.refetch();
      this.closeModal();
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  updateCurriculumPrograms = async orgDetails => {
    const { updateCurriculumPrograms, getOrganizationFeed } = this.props;

    const { id, curriculumPrograms } = orgDetails;

    const curriculumOptions = this.getCurriculumOptionsPayload({
      curriculumPrograms,
      shouldIncludeId: true,
    });

    const dpCurriculumProgram = this.getDPCurriculumProgram({
      curriculumPrograms,
    });

    const {
      examSessionMonth = null,
      examSessionTimezone = null,
    } = dpCurriculumProgram;

    this.setState({ isLoading: true });

    try {
      await updateCurriculumPrograms({
        id,
        curriculumOptions,
        examSessionMonth,
        timezone: examSessionTimezone,
      });

      this.resetPortalType();
      await getOrganizationFeed.refetch();

      this.closeModal();
    } catch (e) {
      console.error(e);
    } finally {
      this.setState({ isLoading: false });
    }
  };

  updateBasicDetails = async updatedOrgDetails => {
    const { getOrganizationFeed, updateOrganizationBasicDetails } = this.props;
    const {
      id,
      name,
      code,
      addedAttachments,
      removedAttachments,
    } = updatedOrgDetails;
    this.setState({ isLoading: true });
    try {
      await updateOrganizationBasicDetails({
        id,
        name,
        code,
        addedAttachments,
        removedAttachments,
      });

      this.resetPortalType();

      await getOrganizationFeed.refetch();
      this.closeModal();
    } finally {
      this.setState({ isLoading: false });
    }
  };

  onClickOperation = async orgDetails => {
    const { mode } = this.state;
    const updatedOrgDetails = _.isEqual(mode, "editBasicDetails")
      ? orgDetails
      : addDisplayOrderIndex({ orgDetails });

    if (mode == "create") {
      this.createOrganization(updatedOrgDetails);
    } else if (mode === "editBasicDetails") {
      this.updateBasicDetails(updatedOrgDetails);
    } else {
      this.updateCurriculumPrograms(updatedOrgDetails);
    }
  };

  getOrgDetail = () => {
    const { organizations } = this.props;
    const { selectedOrgId } = this.state;
    const orgDetails = _.get(
      _.find(organizations, ({ node }) => {
        return node.id === selectedOrgId;
      }),
      "node",
      {}
    );
    return {
      id: _.get(orgDetails, "id", ""),
      name: _.get(orgDetails, "name", ""),
    };
  };

  getBuddies = () => {
    const { getOrganizationFeed } = this.props;
    return _.get(getOrganizationFeed, "platform.toddleBuddies", []);
  };

  onScroll = e => {
    const { modalOpen } = this.state;

    const { hasNextPage, networkStatus, loadMoreResult } = this.props;
    const containerDiv = e.target;

    if (
      !modalOpen &&
      containerDiv &&
      hasNextPage &&
      networkStatus != 3 &&
      checkScrollAtBottom(containerDiv)
    ) {
      loadMoreResult();
    }
  };

  onSwitchToOrganization = ({ id, region }) => {
    const { onSwitchToOrganization } = this.props;

    this.setState({ isLoading: true });

    this.setPortalTypeByRegion(region);

    onSwitchToOrganization({ organizationId: id });
  };

  onDialogConfirmClick = async () => {
    const { currentDialogAction } = this.state;
    const { getOrganizationFeed, deleteOrganization } = this.props;
    try {
      this.setState({ isLoading: true });
      if (currentDialogAction === "DELETE_ORGANIZATION") {
        await deleteOrganization({
          variables: { id: this.state.selectedOrgId },
        });
      }

      this.resetPortalType();

      await getOrganizationFeed.refetch();
    } catch {
    } finally {
      this.setState({ isLoading: false });
    }
  };

  onUpdateCloudStorageAccount = async value => {
    const { getOrganizationFeed, editSchoolCloudStorageAccount } = this.props;
    try {
      this.setState({ isLoading: true, editStorageAccountModalOpen: false });

      await editSchoolCloudStorageAccount({
        id: this.state.selectedOrgId,
        value,
      });

      this.resetPortalType();

      await getOrganizationFeed.refetch();
    } catch {
    } finally {
      this.setState({ isLoading: false });
    }
  };

  getToddleBuddies = () => {
    const { getOrganizationFeed } = this.props;
    return _.get(getOrganizationFeed, "platform.buddies", []);
  };

  onFilterClick = value => {
    const { updateOrganizationFilters, activeTab } = this.props;
    switch (activeTab) {
      case "TRANSITION": {
        updateOrganizationFilters({ transitionFilter: value });
        break;
      }
      case "ALL_SCHOOLS": {
        updateOrganizationFilters({ plan: value });
      }
    }
  };

  getFiltersBlockProps = () => {
    const {
      activeTab,
      transitionAnalytics,
      transitionFilter,
      planFilterValue,
      subscriptionPlanAnalytics,
    } = this.props;
    switch (activeTab) {
      case "TRANSITION":
        return {
          filters: getTransitionFilters(transitionAnalytics),
          activeFilter: transitionFilter,
        };
      case "ALL_SCHOOLS": {
        return {
          filters: getCurriculumPlanFilters(subscriptionPlanAnalytics),
          activeFilter: planFilterValue,
        };
      }
      default:
        return {};
    }
  };

  getColumnList = () => {
    const { activeTab } = this.props;
    switch (activeTab) {
      case "ALL_SCHOOLS": {
        return ALLSCHOOLS_SCHOOL_PAGE_COLUMNS;
      }
      case "TRANSITION": {
        return TRANSITION_SCHOOL_PAGE_COLUMNS;
      }
    }
  };

  onOrganizationClick = id => {
    const [organizationId, region] = _.split(id, " ");
    this.onSwitchToOrganization({ id: organizationId, region });
  };

  toggleSchoolInfoModal = () => {
    this.setState({
      schoolInfoModalOpen: false,
      selectedOrganization: null,
    });
  };

  closeManageTagsModal = () => {
    this.setState({
      manageTagsModalOpen: false,
      selectedOrganization: null,
    });
  };

  closeEditStorageAccountModal = () => {
    this.setState({
      editStorageAccountModalOpen: false,
    });
  };

  render() {
    const {
      isData,
      isLoading,
      networkStatus,
      activeTab,
      updateOrganizationFilters,
      buddyFilterValue,
      planFilterValue,
      feedAnalytics,
      isCreateOrganizationEnabled,
      totalCount,
      isPaidOrgFilterValue,
      children,
    } = this.props;
    const {
      mode,
      modalOpen,
      academicYearModalOpen,
      currentDialogAction,
      bulkUploadErrorModal,
      errors,
      selectedOrgId,
      isLoading: isStateLoading,
      schoolInfoModalOpen,
      selectedOrganization,
      manageTagsModalOpen,
      editStorageAccountModalOpen,
    } = this.state;

    return children ? (
      children
    ) : (
      <div className={classes.container} onScroll={e => this.onScroll(e)}>
        <TopHeader
          goToBack={this.props.goToBack}
          onClickAdd={this.openModalCreateModeal}
          activeTab={activeTab}
          updateOrganizationFilters={updateOrganizationFilters}
          feedAnalytics={feedAnalytics}
          isCreateOrganizationEnabled={isCreateOrganizationEnabled}
        />

        <FilterCountBlock
          onFilterClick={this.onFilterClick}
          {...this.getFiltersBlockProps()}
          activeCountStyle={styles.countStyle}
          activeLabelStyle={styles.labelStyle}
        />

        <div className={classes.innerContainer}>
          <FilterContainer
            searchText={this.props.searchText}
            changeSearchTerm={this.changeSearchTerm}
            toddleBuddies={this.getToddleBuddies()}
            planFilterValue={planFilterValue}
            buddyFilterValue={buddyFilterValue}
            isPaidOrgFilterValue={isPaidOrgFilterValue}
            showPlanFilter={activeTab !== "ALL_SCHOOLS"}
            totalCount={totalCount}
          />

          <OrganizationList
            columnList={this.getColumnList()}
            parentStyle={this.getFeedListParentStyle()}
            feedData={this.getFeedDataV2()}
            fetchMoreFeed={this.fetchMoreFeed}
            isData={isData}
            getCustomComponent={this.getCustomColumnElement}
            isLoading={isLoading}
            onItemClick={this.onOrganizationClick}
            isItemClickEnable
          />
        </div>
        {modalOpen ? (
          <UIModal isOpen isFullScreen customStyle={customModalStyle}>
            <EditOrgInfo
              bulkUpload={this.props.bulkUpload}
              closeModal={this.closeModal}
              mode={mode}
              onClickOperation={this.onClickOperation}
              organizationId={selectedOrgId}
              toddleBuddies={this.getToddleBuddies()}
              filters={this.props.filters}
            />
          </UIModal>
        ) : null}

        {academicYearModalOpen ? (
          <UpdateOrgAcademicYears
            closeModal={this.closeModal}
            mode={mode}
            organizationId={selectedOrgId}
          />
        ) : null}

        {currentDialogAction ? (
          <DialogueBox
            modalTitle={DIALOGS_INFO[currentDialogAction].title}
            onClickButton2={this.onDialogConfirmClick}
            modalBody={DIALOGS_INFO[currentDialogAction].message({
              orgDetail: this.getOrgDetail(),
            })}
            toggleDialogueBoxDisplay={this.toggleDialogueBoxDisplay}
            button1={DIALOGS_INFO[currentDialogAction].cancelButtonText}
            button2={DIALOGS_INFO[currentDialogAction].confirmButtonText}
          />
        ) : null}

        {editStorageAccountModalOpen ? (
          <EditStorageAcountModal
            closeModal={this.closeEditStorageAccountModal}
            onUpdate={this.onUpdateCloudStorageAccount}
          />
        ) : null}

        {bulkUploadErrorModal ? (
          <BulkUploadErrorModal
            toggleBulkUploadErrorModal={this.toggleBulkUploadErrorModal}
            errors={errors}
          />
        ) : null}

        {schoolInfoModalOpen ? (
          <SchoolInfo
            organization={selectedOrganization}
            onClose={this.toggleSchoolInfoModal}
          />
        ) : null}

        {manageTagsModalOpen ? (
          <ManageTagsModal
            organization={selectedOrganization}
            closeManageTagsModal={this.closeManageTagsModal}
            setIsLoading={this.setIsLoading}
          />
        ) : null}

        {networkStatus == 3 ? (
          <div className={classes.loadingContainer}>
            <Loading />
          </div>
        ) : null}
        {isStateLoading ? <FullScreenLoader></FullScreenLoader> : null}
      </div>
    );
  }
}

const mapActionCreators = {
  createOrganization,
  goToBack,
  bulkUpload,
  changeOrganizationSearchString,
  onSwitchToOrganization,
  deleteOrganization,
  updateConfigurablePermissions,
  updateOrganizationFilters,
  updateOrganizationPaidStatus,
  setToastMsg,
  updateCurriculumPrograms,
  updateOrganizationBasicDetails,
  bulkDownloadOrganizationData,
  setPortalType,
  goToRelativeRoute,
  editSchoolCloudStorageAccount,
};

const globalConstantsFilter = {
  names: ["THIRD_PARTY_SERVICE_TYPE_PREFERENCE"],
};

const mapStateToProps = (state, ownProps) => {
  const {
    tab,
    toddleBuddy,
    plan,
    transitionFilter,
    regionIds,
    isPaidOrganizationKey,
  } = state.tooling.organizationFilters;

  const searchText = state.tooling.searchString.organizations;
  const memoizedFilters = getFiltersMemoized({
    tab,
    toddleBuddy,
    plan,
    searchText,
    transitionFilter,
    regionIds,
  });

  const { value = undefined } = getIsPaidOrganizationValue({
    isPaidOrganizationKey,
  });

  const filters = {
    ...memoizedFilters,
    isPaidOrganization: value,
  };

  const tagFilters = {
    keys: "BILLING_TAG",
  };

  const configurationType = ORGANIZATIONS;
  const isCreateOrganizationEnabled = ACLStore.can(
    _.get(IDENTITY_CONFIGURATION_TYPE_TO_PERM_MAP, CREATE_ORGANIZATION)
  );

  const isDeleteOrganizationEnabled = ACLStore.can(
    _.get(IDENTITY_CONFIGURATION_TYPE_TO_PERM_MAP, DELETE_ORGANIZATION)
  );
  const enableEditCloudStorageAccount = ACLStore.can(
    "IdentityAccess:EditSchoolCloudStorageAccount"
  );

  return {
    isData: true,
    isLoading: false,
    mode: ownProps.mode,
    searchText,
    activeTab: tab,
    buddyFilterValue: toddleBuddy,
    planFilterValue: plan,
    isPaidOrgFilterValue: isPaidOrganizationKey,
    filters,
    tagFilters,
    globalConstantsFilter,
    transitionFilter,
    accessPermissions: _.get(
      IDENTITY_CONFIGURATION_TYPE_TO_PERM_MAP,
      configurationType
    ),
    // TODO:CLEANUP_PAM -> Remove Acl store condition once internal tools and pam are on identity completely
    isCreateOrganizationEnabled:
      isCreateOrganizationEnabled ||
      ACLStore.can("ToolPortal:EnableCreateOrganization"),
    isDeleteOrganizationEnabled,
    enableEditCloudStorageAccount,
  };
};

// export default Organization;
export default compose(
  I18nHOC({ resource: ["toastMsgs", "onBoarding", "common"] }),
  connect(mapStateToProps, mapActionCreators),
  withCombinedAccessBlocker,
  graphql(getOrganizationFeedQuery, {
    name: "getOrganizationFeed",
    options: ({
      filters,
      tagFilters,
      globalConstantsFilter,
      enableEditCloudStorageAccount,
    }) => ({
      fetchPolicy: "cache-and-network",
      variables: {
        filters,
        tagFilters,
        globalConstantsFilter,
        fetchGlobalConstants: enableEditCloudStorageAccount,
      },
    }),
    props({
      getOrganizationFeed,
      ownProps: {
        isData,
        isLoading,
        filters,
        tagFilters,
        globalConstantsFilter,
        enableEditCloudStorageAccount,
      },
    }) {
      const organizationDetails = getOrganizationFeedFromCache({
        filters,
        tagFilters,
        globalConstantsFilter,
        enableEditCloudStorageAccount,
      });
      const organizations = _.get(organizationDetails, "edges", []);
      const totalCount = _.get(organizationDetails, "totalCount", 0);
      const feedAnalytics = _.get(organizationDetails, "feedAnalytics", {});
      const onboardingAnalytics = _.get(
        organizationDetails,
        "onboardingAnalytics",
        {}
      );
      const transitionAnalytics = _.get(
        organizationDetails,
        "transitionAnalytics",
        {}
      );
      const subscriptionPlanAnalytics = _.get(
        organizationDetails,
        "subscriptionPlanAnalytics",
        {}
      );
      return {
        totalCount,
        feedAnalytics,
        onboardingAnalytics,
        transitionAnalytics,
        subscriptionPlanAnalytics,
        organizations,
        getOrganizationFeed,
        hasNextPage: _.get(organizationDetails, "pageInfo.hasNextPage", false),
        networkStatus: getOrganizationFeed["networkStatus"],
        isData: !_.isEmpty(organizationDetails) && isData,
        isLoading:
          getOrganizationFeed["networkStatus"] == 1 ||
          getOrganizationFeed["networkStatus"] == 2 ||
          isLoading,
        loadMoreResult: () => {
          return getOrganizationFeed.fetchMore({
            variables: {
              after: organizationDetails.pageInfo.endCursor,
              filters,
            },
            updateQuery: (previousResult, { fetchMoreResult }) => {
              const previousFeed = previousResult.platform.organizationFeed;
              const nextFeed = fetchMoreResult.platform.organizationFeed;

              const previousEdges = previousFeed.edges;
              const nextEdges = nextFeed.edges;

              const previousPageInfo = previousFeed.pageInfo;
              const nextPageInfo = nextFeed.pageInfo;

              const nextEndCursor = nextPageInfo.endCursor;
              const nextHasNextPage = nextPageInfo.hasNextPage;
              return {
                ...previousResult,
                platform: {
                  ...previousResult.platform,
                  organizationFeed: {
                    ...previousResult.platform.organizationFeed,
                    edges: [...previousEdges, ...nextEdges],
                    pageInfo: {
                      ...previousPageInfo,
                      endCursor: nextEndCursor,
                      hasNextPage: nextHasNextPage,
                    },
                  },
                },
              };
            },
          });
        },
      };
    },
  })
)(OrganizationV2);
